const trackApplicationError = (name: string, error: Error): void => {
  console.log(`${name}: ${error.message}`);
};

export abstract class Failure {
  constructor(protected name: string, error: Error) {
    trackApplicationError(name, error);
  }
}
